module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2296a0aa7efc4539debb5ef94a56da61.png";